import AbstractCommand from "../../../core/application/AbstractCommand";
import NGTVariableManager from "../../../ngt/base/NGTVariableManager";
import MapModel from "../../map/model/MapModel";
import MapsConfig from "../../map/model/MapsConfig";
import ProgressGameModel from "../../save-game/model/ProgressGameModel";
import StoryVariables from "../../util/StoryVariables";

export default class VariableChangedCommand extends AbstractCommand {
    /**
     * @constructor
     * @param {soma.EventDispatcher} dispatcher 
     * @param {NGTVariableManager} variableManager 
     * @param {MapsConfig} mapsConfig 
     * @param {MapModel} mapModel 
     * @param {ProgressGameModel} progressGameModel 
     */
    constructor(dispatcher, variableManager, mapsConfig, mapModel, progressGameModel) {
        super(dispatcher);

        this._variableManager = variableManager;
        this._mapsConfig = mapsConfig;
        this._mapModel = mapModel;
        this._progressGameModel = progressGameModel;
    }

    execute(evt) {
        const data = evt.params.data;
        const variableName = data.variable;

        switch (variableName) {
            case StoryVariables.CHAPTER:
            case StoryVariables.WEEK_NUMBER:
            case StoryVariables.PATH:
                this._handleChapterVariableChange();
                break;
        }
    }

    // NOTE: In a later stage we should split each chapter in its own story file.
    //       When this is the case we won't need to change based on variable anymore, but just once in the 'PlayScenarioCommand'.
    _handleChapterVariableChange() {
        const chapter = this._variableManager.solve(StoryVariables.CHAPTER);
        const week = this._variableManager.solve(StoryVariables.WEEK_NUMBER);
        
        this._progressGameModel.chapter = chapter;
        this._progressGameModel.week = week;

        let map = null;

        // First try to get a map with specific week number.
        map = this._mapsConfig.getMapById(`chapter_${chapter}w${week}`);

        // If no map with specific week number exists get the one without a week number.
        if (!map) {
            map = this._mapsConfig.getMapById(`chapter_${chapter}`);
        }

        this._mapModel.setCurrentMap(map);
    }
}
